// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggleButton {\n    background-color: #fafafa ;\n    color: #0E5371;\n    width: 100px;\n    border: none;\n    box-shadow: 1px 1px 3px 0px #707070;\n    height: 50px;\n    font-weight: bold;\n}\n\n.react-calendar-timeline .rct-header-root {\n    background: #0E5371 !important;\n    border-bottom: 1px solid #bbb; }\n", ""]);
// Exports
module.exports = exports;
